import React, { useEffect, useRef, useState } from "react";
import vAdminformat from "../../adminFormat";


import config from '../../config';
import axios from "axios";
import { headers } from "../../token";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";
import JobLiveUpdate from "./JobLiveUpdate";
import SimpleSTLViewer from "../Canvas/SimpleStlViews";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";

import AddLiveJobComment from "./AddLiveJobComment";
import getFileExtension from "../getFileExtension";
import { PieChart, Pie, Cell } from "recharts";

const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const WaxMouldFolderViewHistory = ({ CloseViewJob, JobID, getJobs }) => {

    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [materialList, setMaterialList] = useState([]);

    const [optionJobs, setOptionJob] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const [files, setFiles] = useState([]);
    const [statusJob, setStatusJob] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [imageURL, setImageURL] = useState(null);
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [jobChilds, setJobChilds] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isPrinted, setIsPrinted] = useState(false);
    const [currentQty, setCurrentQty] = useState(0);
    const [formData, setFormData] = useState({

    });

    useEffect(() => {
        const getCurrentJob = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/manual/select?id=${JobID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    setTrackingView(data.trackings);
                    setJobChilds(data.jobs_childs);
                    setFormData({
                        ...data,
                        mat_id: data.mat_ID,
                        ordj_id: data.ordj_ID,
                        file_id: data.file_ID,
                        est_id: data.est_ID,
                        job_id: JobID,
                        discount_ptg: parseFloat(data.discount_ptg).toFixed(2)
                    });

                    let image = null;
                    if (data.isMould === 1) {
                        image = `${server_backend}/${data.files_path_file}`
                    } else {
                        image = await SimpleSTLViewerToImage(`${server_backend}/${data.files_path_file}`);
                    }

                    setImageURL(image);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            } finally {
                setLoading(false)

            }
        }
        getCurrentJob();
    }, []);

    const getCurrentJob = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${server_backend}/jobs/manual/select?id=${JobID}`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                setTrackingView(data.trackings);
                setJobChilds(data.jobs_childs);
                setFormData({
                    ...data,
                    mat_id: data.mat_ID,
                    ordj_id: data.ordj_ID,
                    file_id: data.file_ID,
                    est_id: data.est_ID,
                    job_id: JobID,
                    discount_ptg: parseFloat(data.discount_ptg).toFixed(2)
                });

                let image = null;
                if (data.isMould === 1) {
                    image = `${server_backend}/${data.files_path_file}`
                } else {
                    image = await SimpleSTLViewerToImage(`${server_backend}/${data.files_path_file}`);
                }

                setImageURL(image);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            setLoading(false)

        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMaterial();
    }, []);


    useEffect(() => {
        const getOptionJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_value/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setOptionJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getOptionJob();
    }, []);

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);

                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusJob();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showAddCommentModal = () => {
        setIsComment(true)
    }
    const StatusChart = ({ statusId, reprint }) => {

        const COLORS = ["#FF0000", "#FF7F50", "#FFFF00", "#008000"];

        if (statusId === 18 && reprint === false) {
            return <i className="ri-folder-open-line" style={{ fontSize: "35px", color: "#555" }}></i>;
        }
        if (statusId === 18 && reprint === true) {
            return <i className="ri-folder-add-line" style={{ fontSize: "35px", color: "#555" }}></i>;
        }

        let filledSections = 0;
        if (filledSections > 22) filledSections = 4;
        switch (statusId) {
            case 19: filledSections = 1; break;
            case 20: filledSections = 2; break;
            case 21: filledSections = 3; break;
            case 22: filledSections = 4; break;
            default: filledSections = 0;
        }


        const data = Array(4).fill(1).map((_, index) => ({
            value: 1,
            color: index < filledSections ? COLORS[index] : "#E0E0E0"
        }));

        return (
            <PieChart width={38} height={38}>
                <Pie
                    data={data}
                    cx="50%" cy="50%"
                    innerRadius={12}  //Empty center size

                    outerRadius={20}  //Total circle size

                    dataKey="value"
                    startAngle={270}
                    endAngle={-180}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
            </PieChart>

        );
    };

    const sendToReprint = async () => {

        Swal.fire({
            title: 'Reprint Confirmation',
            text: 'Are you sure you want to reprint the selected Jobs?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Reprint',
            cancelButtonText: 'No, Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {

                if (selectedFiles.length === 0) {
                    Swal.fire({
                        icon: 'error',
                        title: 'No files selected',
                        text: 'Please select at least one file to reprint.',
                    });
                    return;
                }

                try {
                    const response = await axios.post(`${server_backend}/jobs/manual/reprint`, {
                        job_id: JobID,
                        files: selectedFiles
                    }, headers);

                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Reprint Successful',
                            text: response.data.RES_MESSAGE,
                        });
                        getCurrentJob();
                    } else {
                        validateError(response.data);
                    }
                } catch (error) {
                    console.log("Unexpected error, please check")
                    Swal.fire({
                        icon: 'error',
                        title: 'Reprint Failed',
                        text: error.message,
                    });
                }
            }
        });
    }

    return (
        <div>
            {isUpdating ? (
                <JobLiveUpdate CloseViewJob={CloseModalUpdate} JobID={JobID} getJobs={getCurrentJob} />
            ) : (

                <div className="">
                    <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center">
                            {/* Icons on the left */}
                            <div className="d-flex gap-2">
                                <button type="button" className="btn btn-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Go Back" onClick={CloseViewJob}>
                                    <i className="ri-arrow-go-back-line"></i>
                                </button>

                                <button type="button" className="btn btn-warning" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={ShowModalUpdate}>
                                    <i className="ri-pencil-fill align-bottom"></i>
                                </button>

                               {/*  <button type="button" className="btn btn-outline-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={() => {
                                    DeletedJob(JobID, getJobs, CloseViewJob);

                                }} style={{ marginRight: "5px" }}>
                                    <i className="ri-delete-bin-5-fill"></i>
                                </button> */}

                            </div>

                            {/* Job Number */}
                            <div className="text-center">
                                <strong> {formData.job_number}</strong>
                                {formData.reprint > 1 && (
                                    <i
                                        className="ri-shopping-bag-3-fill"
                                        style={{ fontSize: "25px", color: "rgb(162 0 0)", marginBottom: "5px" }}
                                    ></i>
                                )}
                                <span
                                    className="badge bg-light text-dark d-flex align-items-center gap-1 border"
                                    style={{ fontSize: "0.75rem" }}
                                    title={formData.isMould ? "Mould" : "Job (STL)"}
                                >
                                    <i className={`ri ${formData.isMould ? 'ri-coin-line' : 'bx bx-cube'} fs-6`}></i>
                                    {formData.isMould ? "Mould" : "Job (STL)"}
                                </span>
                            </div>

                            {/* Right icons */}

                            <div className="d-flex">

                                {selectedFiles && selectedFiles.length > 0 && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary d-flex align-items-center"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Resend selected jobs to the print queue"
                                        onClick={sendToReprint}
                                        style={{ marginRight: "5px" }}
                                    >
                                        <i className="ri-refresh-line me-2"></i>
                                        Send to Reprint Queue
                                    </button>
                                )
                                }

                                <button type="button" className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={handleClick} style={{ marginRight: "5px" }}>
                                    <i className="ri-printer-line"></i>
                                </button>

                                <button type="button" className="btn btn-success" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={() => {
                                    setSelectedFiles(formData.job_ID);

                                    setIsPrinted(false)
                                    showAddCommentModal()
                                }
                                }>
                                    <i className="mdi mdi-printer-check"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 card card-body">
                        <form >
                            <div className="row">
                                <h5>Order Info</h5><br /><br />
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="name" className="form-label">Order No. </label>
                                                        <span class="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="name"
                                                                name="name"
                                                                value={formData.ord_ID}
                                                                required
                                                                disabled
                                                            />

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="phone" className="form-label">Customer ID</label>
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            value={formData.cust_ID}

                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <label htmlFor="phone" className="form-label">Customer Name</label>
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            disabled
                                                            id="phone"
                                                            name="phone"
                                                            value={formData.fullname}

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-4">
                                            <div className="row">
                                                {/* QR 2 */}
                                                <div className="col-6 d-flex flex-column justify-content-center align-items-center">
                                                    {formData.barcode && (
                                                        <>
                                                            <label class="form-label">Single QR</label>
                                                            <QRCode
                                                                size={300}
                                                                style={{ width: "18vh", height: "auto" }}
                                                                value={`${server_frontend}/jobs/qr-single-job?qr=${formData.barcode}`}
                                                                viewBox="0 0 256 256"
                                                            />

                                                        </>
                                                    )}
                                                </div>

                                                {/* QR 1 */}
                                                <div className="col-6 d-flex flex-column justify-content-center align-items-center">
                                                    {formData.colle_id > 0 ? (
                                                        <>
                                                            <label class="form-label">Collective QR</label>
                                                            <QRCode
                                                                size={25}
                                                                style={{ height: "auto", width: "18vh" }}
                                                                value={`${server_frontend}/jobs/collective/qr-group?group=${formData.colle_id}`}
                                                                viewBox="0 0 256 256"
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <label class="form-label">Collective QR</label>
                                                            <div
                                                                style={{
                                                                    height: "18vh",
                                                                    width: "18vh",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    border: "2px solid #ccc",
                                                                    fontSize: "10px",
                                                                    color: "#666",
                                                                    textAlign: "center",
                                                                    padding: "5px",
                                                                }}
                                                            >
                                                                No assigned <br />group
                                                            </div>
                                                        </>
                                                    )}
                                                </div>


                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <h5 style={{ paddingBlock: "9px" }}>Files</h5>

                                <div className="row mb-3">

                                    <div className="col-6 d-flex flex-column justify-content-between" style={{ height: "100%" }}>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="files" className="form-label">Files</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="files"
                                                        name="files"
                                                        value={formData.files_name}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="qty" className="form-label">Qty</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="qty"
                                                        name="qty"
                                                        value={formData.qty}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Metal Type</label>
                                            <select
                                                className="form-select"
                                                name="optjc_id"
                                                value={formData.mat_id}
                                                disabled
                                            >
                                                <option>Select the option</option>
                                                {materialList.map((OptionJ) => (
                                                    <option key={OptionJ.mat_ID} value={OptionJ.mat_ID}>
                                                        {OptionJ.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div style={{ height: "25vh", width: "100%" }}>
                                            {formData?.files_path_file && getFileExtension(formData.files_path_file) === "stl" ? (
                                                <SimpleSTLViewer url={`${server_backend}/${formData.files_path_file}`} />
                                            ) : formData.files_path_file ? (
                                                <img
                                                    src={`${server_backend}/${formData.files_path_file}`}
                                                    alt="Selected File"
                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                />
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="col-6 d-flex flex-column" style={{ height: "100%" }}>
                                        <label htmlFor="optjc_id" className="form-label">Awaiting Components</label>

                                        <div
                                            style={{
                                                maxHeight: "45vh",
                                                overflowY: "auto",
                                                fontSize: "12px",
                                                border: "1px solid rgb(220, 220, 220)",
                                                height: "100%",
                                            }}
                                        >
                                            <div
                                                key={formData.job_number}
                                                style={{
                                                    display: "flex",
                                                    padding: "6px 8px",
                                                    borderBottom: "1px solid #f0f0f0",
                                                    alignItems: "center",
                                                }}
                                            >

                                                <div style={{ width: "12%", display: "flex", justifyContent: "center" }}>
                                                    <div className="form-check m-0 p-0 d-flex align-items-center">
                                                        <button
                                                            className="btn btn-outline-warning btn-sm "
                                                            type="button"
                                                            onClick={() => {
                                                                setSelectedFiles(formData.job_ID);
                                                                setCurrentQty(formData.qty);
                                                                setIsPrinted(true);
                                                                showAddCommentModal();
                                                            }}
                                                            title="Reprint"
                                                        >
                                                            <i className="mdi mdi-printer-check"></i>
                                                        </button>
                                                    </div>
                                                </div>


                                                <div style={{ width: "20%" }}>
                                                    <h6 className="mb-0 text-truncate">{formData.job_number}</h6>
                                                </div>


                                                <div style={{ width: "15%" }}>
                                                    <h6 className="mb-0">x{formData.qty}</h6>
                                                </div>


                                                <div
                                                    style={{
                                                        width: "25%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    title={
                                                        formData.est_ID === 18 && formData.reprint > 1
                                                            ? "REPRINT FOLDER"
                                                            : formData.status_name
                                                    }
                                                >
                                                    <span className="text-muted small">
                                                        {formData.est_ID === 18 && formData.reprint > 1
                                                            ? "REPRINT FOLDER"
                                                            : formData.status_name}
                                                    </span>
                                                </div>


                                                <div className="d-flex justify-content-end" style={{ width: "25%", textAlign: "center" }}>
                                                    <StatusChart
                                                        statusId={formData.est_ID}
                                                        reprint={formData.est_ID === 18 && formData.reprint > 1}
                                                    />
                                                </div>
                                            </div>
                                            {jobChilds && jobChilds.length > 0 && jobChilds.map((Jobs_L) => (
                                                <div
                                                    key={Jobs_L.job_number}
                                                    style={{
                                                        display: "flex",
                                                        padding: "6px 8px",
                                                        borderBottom: "1px solid #f0f0f0",
                                                        alignItems: "center",
                                                    }}
                                                >

                                                    <div style={{ width: "12%", display: "flex", justifyContent: "center" }}>
                                                        <div className="form-check m-0 p-0 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-warning btn-sm "
                                                                onClick={() => {
                                                                    setSelectedFiles(Jobs_L.job_ID);
                                                                    setCurrentQty(Jobs_L.qty);
                                                                    setIsPrinted(true);
                                                                    showAddCommentModal();
                                                                }}
                                                                title="Reprint"
                                                            >
                                                                <i className="mdi mdi-printer-check"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div style={{ width: "20%" }}>
                                                        <h6 className="mb-0 text-truncate">{Jobs_L.job_number}</h6>
                                                    </div>


                                                    <div style={{ width: "15%" }}>
                                                        <h6 className="mb-0">x{Jobs_L.qty}</h6>
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: "25%",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                        title={
                                                            Jobs_L.est_ID === 18 && Jobs_L.reprint > 1
                                                                ? "REPRINT FOLDER"
                                                                : Jobs_L.status_name
                                                        }
                                                    >
                                                        <span className="text-muted small">
                                                            {Jobs_L.est_ID === 18 && Jobs_L.reprint > 1
                                                                ? "REPRINT FOLDER"
                                                                : Jobs_L.status_name}
                                                        </span>
                                                    </div>


                                                    <div className="d-flex justify-content-end" style={{ width: "25%", textAlign: "center" }}>
                                                        <StatusChart
                                                            statusId={Jobs_L.est_ID}
                                                            reprint={Jobs_L.est_ID === 18 && Jobs_L.reprint > 1}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>

                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="comment" className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="comment"
                                            name="comment"
                                            value={formData.comment}
                                            disabled

                                        ></textarea>
                                    </div>
                                </div>

                                <h5 style={{ paddingBlock: "18px" }}>Additional Information</h5>
                                <div className="row">


                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">3D Print</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.print_type}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 1)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Print Charge (£)</label>
                                            <div className="position-relative">

                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    value={formData.print_charge || ""}
                                                    onKeyDown={() => setShowOptions(false)}
                                                    onFocus={() => setShowOptions(true)}
                                                    disabled
                                                />

                                                {showOptions && (
                                                    <div
                                                        className="dropdown-menu show position-absolute w-100 mt-1"
                                                        style={{
                                                            maxHeight: "200px",
                                                            overflowY: "auto",
                                                            zIndex: 1050,
                                                        }}
                                                    >
                                                        {[...new Map(
                                                            optionJobs
                                                                .filter(option => option.optjc_ID === 2)
                                                                .map(option => [option.name, option])
                                                        ).values()].map((uniqueOption) => (
                                                            <button

                                                                className="dropdown-item"
                                                                type="button"
                                                                onClick={() => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        price: uniqueOption.value,
                                                                    });
                                                                    setShowOptions(false);
                                                                }}
                                                            >
                                                                {uniqueOption.name}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Print Discount (%)</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.discount_ptg}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 3)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={parseFloat(uniqueOption.value).toFixed(2)}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Moulding</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.moulding}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 4)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Mould Only</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.mould_only}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 5)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Expected Cast Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                value={formData.date_estimated}
                                                required
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">


                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Sprue Master</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.sprue_master}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 6)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.value}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Sprue Material</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.sprue_material}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 7)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Metal</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.sprue_feed}

                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 8)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <label htmlFor="quantityInput" className="form-label">Injection Wax Quantity</label>
                                        <div className="input-step d-flex align-items-center w-100">
                                            <input
                                                type="number"
                                                className="form-control text-center mx-2 product-quantity w-100"
                                                value={formData.wax_qty}
                                                min="0"
                                                max="100"
                                                disabled

                                            />
                                        </div>
                                    </div>

                                    <div className="col-9">
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">Quantity or Designate </label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    value={formData.designate}

                                                    required
                                                    disabled
                                                />

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Post</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.post}
                                                disabled
                                            ><option>Select the option</option>
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 9)
                                                        .map(option => [option.name, option])
                                                ).values()].map(uniqueOption => (
                                                    <option value={uniqueOption.optjv_ID}>
                                                        {uniqueOption.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Status</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.est_id}

                                                disabled
                                            ><option>Select the option</option>
                                                {statusJob.map(status => (
                                                    <option value={status.est_ID}>
                                                        {status.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <h5 style={{ paddingBlock: "9px" }}>Other Information</h5>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="user_transaction"
                                            value={vAdminformat.FormatDate(formData.date_created)}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">User Created</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="user_transaction"
                                            value={formData.user_created}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="user_transaction"
                                            value={formData.date_modify && vAdminformat.FormatDate(formData.date_modify)}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="user_transaction"
                                            value={formData.user_modify}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>


                            </div>
                        </form>
                        <div style={{ marginBlock: "50px" }}>
                            <center><h5>Reason for Print</h5></center>
                            <div className="position-relative" id="users-chat" style={{ overflow: "auto", border: '1px solid #80808069' }}>
                                <div className="chat-conversation p-3 p-lg-4 " id="chat-conversation" data-simplebar >
                                    <ul className="list-unstyled chat-conversation-list" id="users-conversation">

                                        {trackingView && trackingView.length > 0 &&
                                            trackingView.map((conv) => (

                                                <li className="chat-list left">
                                                    <div className="chat-avatar">
                                                        <img src="assets/images/users/user-dummy-img.jpg" alt="dbc" />
                                                    </div>
                                                    <div className="conversation-list">
                                                        <div className="user-chat-content">
                                                            <div>
                                                                <div className="ctext-wrap-content  p-2">
                                                                    <strong><p className="mb-0 ctext-content text-bold">{conv.title}</p></strong>
                                                                    <p className="text-muted m-0">{conv.comment}</p>
                                                                </div>
                                                            </div>
                                                            <div className="conversation-name"><small className="text-muted time">{vAdminformat.FormatDate(conv.date_created)} | {conv.user_created}</small> <span className="text-success check-message-icon"><i className="ri-check-double-line align-bottom"></i></span></div>
                                                        </div>
                                                    </div>
                                                </li>

                                            ))}

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )
            }

            <div>

                {showPrintableDiv && (
                    <div ref={componentRef} id="printable-area" className="container mt-4 p-4" style={{ width: '360px', borderRadius: '16px' }}>
                        <div className="row">
                            <div className="col-12 text-start">
                                <strong>{formData.fullname}</strong>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-12 text-start">
                                <a href="#" style={{ fontWeight: 'bold', color: '#007bff', fontSize: '14px' }}>{formData.job_number}</a>
                                <br />

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <span
                                    className="badge bg-light text-dark d-flex align-items-center gap-1 border"
                                    style={{ fontSize: "0.75rem" }}
                                    title={formData.isMould ? "Mould" : "Job (STL)"}
                                >
                                    <i className={`ri ${formData.isMould ? 'ri-coin-line' : 'bx bx-cube'} fs-6`}></i>
                                    {formData.isMould ? "Mould" : "Job (STL)"}
                                </span>
                                {imageURL ? (
                                    <img
                                        src={imageURL}
                                        alt="STL Image"
                                        style={{ width: '100%', height: 'auto', border: '1px solid #ccc' }}
                                    />
                                ) : (
                                    <p>Loading Image...</p>
                                )}

                            </div>

                            <div className="col-6 d-flex flex-column justify-content-center align-items-center">
                                {formData?.colle_id ? (
                                    <div className="text-center mb-2">
                                        <div style={{ fontSize: '10px', marginBottom: '4px' }}>Group ID</div>
                                        <QRCode
                                            size={143}
                                            value={`${server_frontend}/jobs/collective/qr-group?group=${formData.colle_id}`}
                                            viewBox="0 0 256 256"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <label class="form-label">Group ID</label>
                                        <div
                                            style={{
                                                height: "10vh",
                                                width: "10vh",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                border: "2px solid #ccc",
                                                fontSize: "10px",
                                                color: "#666",
                                                textAlign: "center",
                                                padding: "5px",
                                            }}
                                        >
                                            No assigned <br />group
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="col-12">
                                <div className="row">
                                    <div className="col-8">
                                        <div className="row mt-4">
                                            <div className="col-12" style={{ fontSize: '13px', border: '1px solid #ccc', borderRadius: '6px', padding: '8px', minHeight: "7vh" }}>
                                                <div><strong>{formData.materials_name}</strong></div>
                                                <div>Qty {formData.quantity || 1}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        {formData?.barcode && (
                                            <div className="text-center mt-2">
                                                <div style={{ fontSize: '10px', marginBottom: '4px' }}>Job ID</div>
                                                <QRCode
                                                    size={80}
                                                    value={`${server_frontend}/jobs/qr-single-job?qr=${formData.barcode}`}
                                                    viewBox="0 0 256 256"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                )}


                {isComment && (
                    <AddLiveJobComment JobID={selectedFiles} onClose={CloseAddCommentModal} getJobs={getCurrentJob} isBegin={isPrinted} Qty={currentQty} />
                )}

            </div>

        </div>


    )
}


export default WaxMouldFolderViewHistory